import { render, staticRenderFns } from "./EditEmailNotification.vue?vue&type=template&id=f0a15ea2&"
import script from "./EditEmailNotification.vue?vue&type=script&lang=js&"
export * from "./EditEmailNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports